/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  socket: any;
  url: string = '';
  constructor() {}

  initSocket(): void {
    if (localStorage.getItem(`${environment.storageKey}`) && localStorage.getItem(`${environment.storageKey}`) !== undefined) {
      this.url = `${environment.socket_url}?token=${localStorage.getItem(environment.storageKey)}`;
      this.socket = io(this.url, {
        reconnection: true
      });
    }
  }


  emitAction(action: any, payload: any): void {
    this.socket.emit(action, payload);
  }

  public onEvent(event: string): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on(event, (data: any) => {
        observer.next(data);
      });
    });
  }

  disconnect() : void {
    this.socket.disconnect();
  }
}
